@if (hasBookmarks) {
  <app-section-shell
    sectionId="bookmarks-collection"
    sectionClass="bookmarks-section"
    sectionTitle="Collection"
    [displayResults]="displayResults"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [currentPage]="currentPage"
    [totalPages]="totalPages"
    [canGoPrev]="canGoPrev"
    [canGoNext]="canGoNext"
    (pageSizeChange)="onPageSizeChange($event)"
    (prevPage)="goToPrevPage()"
    (nextPage)="goToNextPage()">
    @for (entry of visibleBookmarks; track $index) {
      @if (isProductDemo(entry)) {
        <div class="bookmark-card video-card">
          <a [href]="entry.item.videoUrl" target="_blank" class="video-thumbnail" (click)="$event.stopPropagation()" aria-label="Play video">
            <img [src]="getThumbnail(entry.item.videoUrl)" [alt]="entry.item.name" class="thumbnail-img" />
            <div class="play-overlay">
              <div class="play-btn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </div>
            </div>
          </a>
          <div class="card-body">
            <div class="card-copy">
              <h4>{{ entry.item.name }}</h4>
              @if (entry.item.description) {
                <p>{{ entry.item.description }}</p>
              }
            </div>
            <div class="card-actions">
              <button class="favorite-btn bookmarked" (click)="toggleProductDemo.emit(entry.item.id)" aria-label="Remove from collection">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </button>
              <a [href]="entry.item.videoUrl" target="_blank" class="card-arrow" aria-label="Open video">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                  <polyline points="15 3 21 3 21 9"/>
                  <line x1="10" y1="14" x2="21" y2="3"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }
      @if (isWorkflowDemo(entry)) {
        <div class="bookmark-card video-card">
          <a [href]="entry.item.videoUrl" target="_blank" class="video-thumbnail" (click)="$event.stopPropagation()" aria-label="Play video">
            <img [src]="getThumbnail(entry.item.videoUrl)" [alt]="entry.item.name" class="thumbnail-img" />
            <div class="play-overlay">
              <div class="play-btn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </div>
            </div>
          </a>
          <div class="card-body">
            <div class="card-copy">
              <h4>{{ entry.item.name }}</h4>
              @if (entry.item.description) {
                <p>{{ entry.item.description }}</p>
              }
            </div>
            <div class="card-actions">
              <button class="favorite-btn bookmarked" (click)="toggleWorkflowDemo.emit(entry.item.id)" aria-label="Remove from collection">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </button>
              <a [href]="entry.item.videoUrl" target="_blank" class="card-arrow" aria-label="Open video">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                  <polyline points="15 3 21 3 21 9"/>
                  <line x1="10" y1="14" x2="21" y2="3"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }
      @if (isUseCase(entry)) {
        <div class="bookmark-card text-card">
          <div class="card-body">
            <div class="card-copy">
              <h4>{{ entry.item.title }}</h4>
              <p>{{ entry.item.description }}</p>
            </div>
            <div class="card-actions">
              <button class="favorite-btn bookmarked" (click)="toggleUseCase.emit(entry.item.id)" aria-label="Remove from collection">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </button>
              <a [href]="entry.item.articleUrl" target="_blank" class="card-arrow" aria-label="Open article">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                  <polyline points="15 3 21 3 21 9"/>
                  <line x1="10" y1="14" x2="21" y2="3"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }
    }
  </app-section-shell>
}

